'use client';

import { CatButton, CatIconMachineExcavator } from '../../blocks-components';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import styles from './no-equipment-selected.module.scss';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { useEffect } from 'react';
import { useLoaderOverlay } from 'app/[lang]/[esite]/contexts/loader-overlay-context';
import useFilter from 'hooks/use-filter';

const NoEquipmentSelected = ({
  hasEquipmentsToSelect,
  onlyRenderButton = false
}: {
  hasEquipmentsToSelect: boolean;
  onlyRenderButton?: boolean;
}) => {
  const {
    addEquipmentDrawer: { openDrawer: openAddEquipmentDrawer },
    selectEquipmentDrawer: { openDrawer: openSelectEquipmentDrawer }
  } = useMyEquipmentDrawer();
  const { setEquipment, setFilterByEquipment, startTransition, equipment } =
    useLoaderOverlay();
  const { handleSortByEquipment } = useFilter();
  const t = useTranslations();
  const title = hasEquipmentsToSelect
    ? 'SELECT_EQUIPMENT'
    : 'ADD_EQUIPMENT_ICON';

  const handleClick = () => {
    hasEquipmentsToSelect
      ? openSelectEquipmentDrawer()
      : openAddEquipmentDrawer();
  };

  useEffect(() => {
    if (equipment.model) {
      setFilterByEquipment(false);
      setEquipment({
        model: '',
        serialNumber: ''
      });
      startTransition(() => {
        handleSortByEquipment(false);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipment.model]);

  const getMobileView = () => (
    <div
      className={cx(
        'd-md-none d-flex flex-column py-4 my-2 w-100',
        styles['equipment-widget__no-equipment-container']
      )}
      data-testid="mobile-widget-view"
    >
      <div className="d-flex flex-column align-items-center">
        <div className="d-flex">
          <CatIconMachineExcavator size="lg" />
          <p
            className={cx(
              'm-0 ps-2',
              styles['equipment-widget__no-equipment-title']
            )}
          >
            {t(title)}
          </p>
        </div>
        <p className="cat-u-theme-typography-body m-0">
          {t('RESULTS_MEQ_ADD_EQUIP')}
        </p>
      </div>
      <CatButton variant="primary" fullWidth size="lg" onClick={handleClick}>
        {t(title)}
      </CatButton>
    </div>
  );

  const getDesktopView = () => (
    <div
      className={cx(
        'd-none d-md-flex flex-column py-3',
        styles['equipment-widget__no-equipment-container']
      )}
    >
      <div className="d-flex">
        <CatIconMachineExcavator size="lg" />
        <div className="px-2">
          <p className="cat-u-theme-typography-title-sm m-0">{t(title)}</p>
          <p className="cat-u-theme-typography-body-sm m-0">
            {t('RESULTS_MEQ_ADD_EQUIP')}
          </p>
        </div>
      </div>
      <CatButton
        variant="primary"
        className={styles['equipment-widget__no-equipment-button']}
        onClick={handleClick}
      >
        {t(title)}
      </CatButton>
    </div>
  );

  if (onlyRenderButton) {
    return (
      <CatButton variant="primary" fullWidth size="sm" onClick={handleClick}>
        {t(title)}
      </CatButton>
    );
  }

  return (
    <>
      {getMobileView()}
      {getDesktopView()}
    </>
  );
};

export default NoEquipmentSelected;
